import { inject, ref, onMounted } from 'vue'

export function useFormFieldPrefillForSingleChoiceWithCustom(uuid, initialValue, options) {
    const fieldValue = ref(initialValue.value || '')
    const prefillValues = inject('formPrefillValues', ref(null))

    const preFill = () => {
        if (prefillValues.value && prefillValues.value[uuid]?.value !== undefined) {
            const prefillValue = prefillValues.value[uuid].value

            // Check if the prefill value matches any of the options
            const matchingOption = options.find(option => option.value === prefillValue)

            if (matchingOption) {
                // If it matches an option, use that value
                fieldValue.value = prefillValue
            } else {
                // If it doesn't match any option, it's a custom answer
                fieldValue.value = prefillValue
            }
        }
    }

    onMounted(() => {
        preFill()
    })

    return {
        fieldValue
    }
}
